import React, { useEffect, useState } from 'react';
import { StatCard } from './charts/StatCard';
import { PieChart } from './charts/PieChart';
import { BarChart } from './charts/BarChart';
import { AdminDataService } from '../services/AdminDataService';
import { UserAnalyticsData } from '../types';
import './UserAnalytics.css';

export const UserAnalytics: React.FC = () => {
  const [data, setData] = useState<UserAnalyticsData | null>(null);

  useEffect(() => {
    const dataService = AdminDataService.getInstance();
    setData(dataService.getUserAnalytics());
  }, []);

  if (!data) return null;

  return (
    <div className="admin-users">
      <h2 className="admin-users__title">User Analytics</h2>

      <div className="admin-users__stats-grid">
        <StatCard
          icon="👥"
          label="Total Users"
          value={data.totalUsers}
          variant="blue"
        />
        <StatCard
          icon="🆕"
          label="New Today"
          value={data.newToday}
          variant="green"
          trend="up"
          trendValue={`${data.newThisWeek} this week`}
        />
        <StatCard
          icon="👤"
          label="Guest Ratio"
          value={`${Math.round(data.guestRatio * 100)}%`}
          variant="orange"
          trend={data.guestRatio > 0.3 ? 'down' : 'up'}
          trendValue={data.guestRatio > 0.3 ? 'High' : 'Low'}
        />
        <StatCard
          icon="📅"
          label="New This Month"
          value={data.newThisMonth}
          variant="purple"
        />
      </div>

      <div className="admin-users__charts">
        <PieChart
          data={data.authMethodBreakdown}
          title="Users by Auth Method"
        />
        {data.topPlayers.length > 0 && (
          <BarChart
            data={data.topPlayers}
            title="Top Players by Games Played"
          />
        )}
      </div>
    </div>
  );
};
